export const fetchDashboardMenuRoute = 'dashboard/menu'
export const fetchMainDataRoute = 'dashboard/meta'

export const fetchStockFiltersRoute = (id_purchase, id_supply_type, id_warehouse) =>
    `products/filters/${id_purchase}/${id_supply_type}/${id_warehouse}`

export const fetchStockProductsRoute = 'products/products'
export const updateStockPriceRoute = 'products/update-price'

export const fetchStatusOrdersRoute = 'orders/orders'
export const fetchOrderRoute = id_number => `orders/order/${id_number}`
export const fetchImeisRoute = id_number => `orders/imeis/${id_number}`

export const fetchPackingListRoute = id_number => `orders/packing-list/${id_number}`

export const fixPackingQuantityRoute = id_number => `orders/fix-quantity/${id_number}`

export const fetchPaymentInfoRoute = 'payment-info/fetch-list'
export const fetchPaymentInfoSubscriptionOrdersRoute = 'payment-info/fetch-subscription-preorders'

export const fetchSalesStatmentRoute = 'purchase-statment/fetch-orders'

export const fetchStatsRoute = 'statistics/fetch-stats'
export const fetchSubcatStatsCharsRoute = 'statistics/fetch-subcat-chars'
export const fetchModalStatsRoute = 'statistics/fetch-modal-stats'

export const fetchServiceApiRoute = 'service/fetch-service'
export const fetchServicesApiRoute = 'service/fetch-services'
export const fetchServiceFilter = 'service/fetch-filter'

export const fetchPriceListApiRoute = 'pricelist/fetch-list'
export const fetchPriceListFilterApiRoute = 'pricelist/fetch-filter'

export const fetchCurrentP2pBidsApiRoute = 'p2p/fetch-current-bids'
export const fetchCompletedP2pBidsApiRoute = 'p2p/fetch-completed-bids'
export const fetchP2pFiltersApiRoute = 'p2p/fetch-filters'
export const approveP2pBidApiRoute = 'p2p/approve'
export const offerBidPrice = 'p2p/offer-price'

export const profileUpdateApiRoute = 'profile/update-profile'
export const profileAvatarDeleteApiRoute = 'profile/delete-avatar'

export const updatePasswordApiRoute = 'profile/update-password'

export const sendVerificationCodeApiRoute = 'profile/send-code'

export const changeEmailApiRoute = 'profile/change-email'

export const fetchMembersApiRoute = 'members'
export const createMembersApiRoute = 'members'

export const deleteMembersApiRoute = 'members'
export const toggleManageProductsApiRoute = 'members/toggle-manage-products'
